import React, { useState } from "react"
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Label, Input, ButtonGroup } from "reactstrap"
import PropTypes from "prop-types"
import Flatpickr from "react-flatpickr"
import "flatpickr/dist/themes/material_blue.css"
import { withTranslation } from "react-i18next"

const ReportModal = ({ isOpen, toggle, onGenerate, t }) => {
  const [dateRange, setDateRange] = useState([])
  const [format, setFormat] = useState("pdf")
  const [includeOfficeExpenses, setIncludeOfficeExpenses] = useState(false)

  const handleCheckboxChange = () => {
    const newValue = !includeOfficeExpenses
    console.log("Checkbox clicked! Current value:", includeOfficeExpenses, "New value:", newValue)
    setIncludeOfficeExpenses(newValue)
  }

  const formatDate = (date) => {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, "0")
    const day = String(date.getDate()).padStart(2, "0")
    return `${year}-${month}-${day}`
  }

  const handleGenerate = () => {
    if (!dateRange || dateRange.length !== 2) {
      alert(t("Please select a date range"))
      return
    }

    const startDate = formatDate(dateRange[0])
    const endDate = formatDate(dateRange[1])

    console.log("Generating report with includeOfficeExpenses:", includeOfficeExpenses)
    onGenerate(startDate, endDate, format, includeOfficeExpenses)
    toggle()
    setDateRange([])
    setFormat("pdf")
    setIncludeOfficeExpenses(false)
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>{t("Generate Report")}</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label>{t("Select Date Range")}</Label>
          <Flatpickr
            className="form-control"
            placeholder={t("Select Date Range")}
            value={dateRange}
            onChange={(dates) => setDateRange(dates)}
            options={{
              mode: "range",
              dateFormat: "Y-m-d",
            }}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t("Report Format")}</Label>
          <div className="d-flex gap-2">
            <Button
              color={format === "pdf" ? "primary" : "outline-primary"}
              onClick={() => setFormat("pdf")}
              className="flex-fill"
            >
              <i className="bx bxs-file-pdf me-1" />
              PDF
            </Button>
            <Button
              color={format === "excel" ? "success" : "outline-success"}
              onClick={() => setFormat("excel")}
              className="flex-fill"
            >
              <i className="bx bxs-file me-1" />
              Excel
            </Button>
          </div>
        </FormGroup>
        <FormGroup check className="mb-3">
          <Input
            type="checkbox"
            id="includeOfficeExpensesCheck"
            name="includeOfficeExpenses"
            checked={includeOfficeExpenses}
            onClick={handleCheckboxChange}
            readOnly
          />
          <Label check for="includeOfficeExpensesCheck" onClick={handleCheckboxChange} style={{ cursor: "pointer" }}>
            {t("Include Office Expenses in Report")}
          </Label>
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          {t("Cancel")}
        </Button>
        <Button color="primary" onClick={handleGenerate}>
          {t("Generate Report")}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

ReportModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  onGenerate: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
}

export default withTranslation()(ReportModal)
